import React, { Fragment } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import Labels from "../labels/Labels";

export default function PayAnyDayPaybacks(props) {
  const columns = [
    {
      field: "id",
      headerName: Labels.getLabel("payAnyDayPaybacks.column.id", "ID"),
      width: 70,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.periodStartDate}
          </Typography>
        );
      },
    },
    {
      field: "transactionDate",
      headerName: Labels.getLabel(
        "payAnyDayPaybacks.column.transactionDate",
        "Transaction Date"
      ),
      width: 130,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.transactionDate}
          </Typography>
        );
      },
    },
    {
      field: "amount",
      headerName: Labels.getLabel("payAnyDayPaybacks.column.amount", "Amount"),
      width: 80,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.amount}
          </Typography>
        );
      },
    },
  ];
  const { isLoading, isError, data } = props;
  return (
    <Fragment>
      {isLoading ? (
        <h4>{Labels.getLabel("payAnyDayPaybacks.loading", "Loading...")}</h4>
      ) : !isError ? (
        <div style={{ height: 300, width: "100%" }}>
          <DataGrid
            columnVisibilityModel={{ id: false }}
            disableSelectionOnClick
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            rows={data?.data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: false,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            sx={{
              "& .MuiButton-root": {
                display: "none",
              },
            }}
          />
        </div>
      ) : (
        <h4>
          {Labels.getLabel(
            "payAnyDayPaybacks.error",
            "An error ocurred, please try again later..."
          )}
        </h4>
      )}
    </Fragment>
  );
}
